// import React, { useContext, useEffect, useState, useRef } from "react";
// import { useLocation, useNavigate } from "react-router-dom";
// import zoomContext from "../../Contexts/zoom-context";
// import mediaContext from "../../Contexts/media-context";
// import ZoomVideo, { VideoQuality } from "@zoom/videosdk";
// import ChatInterface from "./chatInterface";
// import BuzzerComponent from "./buzzer";
// import io, { Socket } from "socket.io-client";
// import { Button, Modal, List, Tooltip } from "antd";
// import ObjectionAlert from "./objectionAlert";
// import { PlayCircleIcon } from "@heroicons/react/24/outline";
// import {
// 	AudioMutedOutlined,
// 	AudioOutlined,
// 	VideoCameraAddOutlined,
// 	VideoCameraFilled,
// 	FullscreenExitOutlined,
// 	FullscreenOutlined,
// 	DesktopOutlined,
// 	PhoneOutlined,
// 	MessageFilled,
// 	StopOutlined,
// 	BookOutlined,
// 	UserOutlined,
// 	MoreOutlined,
// 	BookFilled,
// } from "@ant-design/icons";
// import { Participant } from "@/src/index-types";
// import UploadEvidence from "./uploadEvidence";
// import EvidenceList from "./evidenceList";
// import ScreenshareContainer from "./ScreenshareContainer";
// import { toast } from "react-toastify";
// import OathAlertComponent from "./oatTakingAlert";
// import OathTaking from "./oat";

// let alreadyOpenedMic = false;
// let controlsTimeoutId: any;

// interface VideoContainerProps {
// 	currentUserRole: any;
// 	sessionName: any;
// 	setIsSessionActive: React.Dispatch<React.SetStateAction<boolean>>;
// 	isSessionActive: boolean;
// 	forPublic?: boolean;
// }

// const VideoContainer: React.FC<VideoContainerProps> = ({
// 	currentUserRole,
// 	setIsSessionActive,
// 	sessionName,
// 	isSessionActive,
// 	forPublic,
// }) => {
// 	const mediaStream = useContext(mediaContext);
// 	const client = useContext(zoomContext);
// 	const navigate = useNavigate();
// 	const location = useLocation();
// 	const params = location.state || {};
// 	const { id: caseId } = params;
// 	const [notificationMessage, setNotificationMessage] = useState("");
// 	const [isShareScreen, setIsShareScreen] = useState(false);
// 	const [isVideooff, setIsVideoOff] = useState(false);
// 	const [isAudioMuted, setIsAudioMuted] = useState(false);
// 	const [isParticipantsModalOpen, setIsParticipantsModalOpen] = useState(false);
// 	const [isMoreModalOpen, setIsMoreModalOpen] = useState(false);
// 	const [isActionModalOpen, setIsActionModalOpen] = useState(false);
// 	const [isOatModalOpen, setIsOatModalOpen] = useState(false);
// 	const [participants, setParticipants] = useState<Array<Participant>>([]);
// 	const [selectedParticipant, setSelectedParticipant] =
// 		useState<Participant | null>(null);
// 	const [isChatOpen, setIsChatOpen] = useState(false);
// 	const currentUser = client?.getCurrentUserInfo();
// 	const [modalPosition, setModalPosition] = useState({
// 		middle: 100,
// 		right: 800,
// 	});
// 	const [isRecording, setIsRecording ] = useState(false)
// 	const [time, setTime] = useState(new Date().toLocaleTimeString());
// 	const moreButtonRefs = useRef<
// 		Record<string, React.RefObject<HTMLButtonElement>>
// 	>({});
// 	const [isLoading, setIsLoading] = useState(false);

// 	const [screenShareActive, setScreenShareActive] = useState<{
// 		active: boolean;
// 		forMe: boolean;
// 		element:
// 			| (() => HTMLVideoElement | HTMLCanvasElement | undefined)
// 			| undefined;
// 	}>({
// 		active: false,
// 		forMe: true,
// 		element: undefined,
// 	});

// 	const [showControls, setShowControls] = useState(true);

// 	const [activeSpeakers, setActiverSpeakers] = useState<number[]>([]);

// 	const toggleChat = () => {
// 		setIsChatOpen(!isChatOpen);
// 	};
// 	const oathRoles = ["WITNESS", "COUNSEL", "CLAIMANT", "DEFENDANT"];

// 	const audioContext = useRef<AudioContext | null>(null);
// 	const processor = useRef<ScriptProcessorNode | null>(null);
// 	const input = useRef<MediaStreamAudioSourceNode | null>(null);
// 	const alreadyOpenedMic = useRef(false);

// 	useEffect(() => {
// 		participants.forEach((participant) => {
// 			if (!moreButtonRefs.current[participant.userId]) {
// 				moreButtonRefs.current[participant.userId] = React.createRef();
// 			}
// 		});
// 	}, [participants]);

// 	const getScreenShareElement = (useVideo: boolean) => {
// 		let element: HTMLVideoElement | HTMLCanvasElement;
// 		if (useVideo) {
// 			element = document.createElement("video");
// 			element.className = "w-full h-auto";
// 			element.setAttribute("height", "1080");
// 		} else {
// 			element = document.createElement("canvas");
// 			element.className = "w-full h-auto";
// 			element.setAttribute("width", "1920");
// 		}

// 		return element;
// 	};

// 	async function renderCurrentUserScreenShare() {
// 		try {
// 			const useVideo = mediaStream?.isStartShareScreenWithVideoElement();
// 			const element = getScreenShareElement(useVideo!);
// 			const currentUserInfo = client?.getCurrentUserInfo();

// 			// Check if element is valid and start screen share
// 			if (element && currentUserInfo) {
// 				await mediaStream?.startShareScreen(element);

// 				// Add user-specific data attribute
// 				element.setAttribute(
// 					"data-user-canvas",
// 					String(currentUserInfo.userId)
// 				);

// 				return element;
// 			}
// 		} catch (error) {
// 			console.error("Error in renderCurrentUserScreenShare:", error);
// 		}
// 	}

// 	async function renderParticipantScreenShare(userId) {
// 		try {
// 			const canvasElement = document.createElement("canvas");
// 			canvasElement.setAttribute("data-user-canvas", String(userId));

// 			// Start sharing the participant's screen
// 			await mediaStream?.startShareView(canvasElement, userId);

// 			return canvasElement;
// 		} catch (error) {
// 			console.error("Error in renderParticipantScreenShare:", error);
// 		}
// 	}

// 	async function stopScreenShare(userId) {
// 		try {
// 			const elementToRemove = document.querySelector(
// 				`[data-user-canvas="${userId}"]`
// 			);
// 			if (elementToRemove) {
// 				elementToRemove.remove();
// 			} else {
// 				console.log(`No screen share found for user ${userId}`);
// 			}
// 		} catch (error) {
// 			console.error("Error in stopScreenShare:", error);
// 		}
// 	}

// 	async function removeVideo(userId: number) {
// 		await mediaStream?.detachVideo(userId);
// 		// document.querySelector(`[data-user-video="${userId}"]`)?.remove();
// 		// setParticipants((prev) => prev.filter((p) => p.userId !== userId));
// 	}
// 	async function addVideo(userId: number) {
// 		await mediaStream?.attachVideo(userId, VideoQuality.Video_720P);
// 		// document.querySelector(`[data-user-video="${userId}"]`)?.remove();
// 		// setParticipants((prev) => prev.filter((p) => p.userId !== userId));
// 	}

// 	async function offVideo(userId: number) {
// 		await mediaStream?.stopVideo();
// 		await mediaStream?.detachVideo(userId);
// 		setIsVideoOff(true)
// 	}
// 	async function onVideo(userId: number) {
// 		await mediaStream?.startVideo();
// 		await mediaStream?.attachVideo(userId, VideoQuality.Video_720P);
// 		setIsVideoOff(false)
// 		// document.querySelector(`[data-user-video="${userId}"]`)?.remove();
// 		// setParticipants((prev) => prev.filter((p) => p.userId !== userId));
// 	}

// 	const renderParticipantsVideo = async () => {
// 		const allParticipants = fetchParticipants();
// 		const newParticipants: Array<Participant> = [];

// 		try {
// 			allParticipants?.forEach(async (participant) => {
// 				if (participant.displayName.startsWith("public-")) {
// 					return;
// 				}

// 				if (participant.bVideoOn) {
// 					await addVideo(participant.userId);
// 				}

// 				newParticipants.push(participant);

// 				console.log(participant, "render");

// 				if (participant.sharerOn) {
// 					const element = await renderParticipantScreenShare(
// 						participant.userId
// 					);
// 					setScreenShareActive({
// 						active: true,
// 						forMe: false,
// 						element: () => element,
// 					});
// 				}
// 			});

// 			setParticipants(newParticipants);
// 		} catch (error) {
// 			console.log(error);
// 		}
// 	};

// 	useEffect(() => {
// 		if (notificationMessage) {
// 			const timer = setTimeout(() => {
// 				setNotificationMessage("");
// 			}, 4000); // Clear notification after 4 seconds

// 			return () => clearTimeout(timer); // Clear timer on cleanup
// 		}
// 	}, [notificationMessage]);

// 	const subscribeToEvents = function () {
// 		client?.on("user-added", async (payload) => {
// 			try {
// 				payload.forEach((pt) => {
// 					console.log(pt?.userId + " joined the session", pt);
// 					setNotificationMessage(pt?.displayName + " Joined the session");
// 				});
// 				const allParticipants = client?.getAllUser();
// 				const validParticipants = allParticipants.filter(
// 					(p) => !p.displayName.startsWith("public-")
// 				);
// 				setParticipants(validParticipants);
// 			} catch (error) {
// 				console.log(error);
// 			}
// 		});

// 		client?.on("user-removed", (payload) => {
// 			payload.forEach((pt) => {
// 				console.log(pt?.userId + " left the session");
// 				setNotificationMessage(pt?.displayName + " left the session");

// 				removeVideo(pt?.userId);
// 			});
// 			const allParticipants = client?.getAllUser();
// 			const validParticipants = allParticipants.filter(
// 				(p) => !p.displayName.startsWith("public-")
// 			);
// 			setParticipants(validParticipants);
// 		});

// 		client?.on("active-share-change", (payload) => {
// 			if (payload.state === "Active") {
// 				renderParticipantScreenShare(payload.userId).then((element) => {
// 					setScreenShareActive({
// 						active: true,
// 						forMe: false,
// 						element: () => element,
// 					});
// 				});
// 			} else if (payload.state === "Inactive") {
// 				mediaStream?.stopShareView();
// 				stopScreenShare(payload.userId);
// 				setScreenShareActive((prev) => ({ ...prev, active: false }));
// 			}
// 		});

// 		client?.on("connection-change", (payload) => {
// 			if ((payload.state === "Closed", payload.reason)) {
// 				// session ended by the host or the SDK kicked the user from the session (use payload.reason to see why the SDK kicked the user)
// 				setNotificationMessage("Connection Closed " + payload.reason);
// 				console.log(payload.reason);
// 			} else if (payload.state === "Reconnecting") {
// 				// the client side has lost connection with the server (like when driving through a tunnel)
// 				// will try to reconnect for a few minutes
// 				setNotificationMessage("Reconnecting...");
// 			} else if (payload.state === "Connected") {
// 				// SDK reconnected the session after a reconnecting state
// 				setNotificationMessage("Connected!");
// 			} else if (payload.state === "Fail") {
// 				// session failed to reconnect after a few minutes
// 				// user flushed from Zoom Video SDK session
// 				setNotificationMessage("Connection Failed!");
// 			}
// 		});

// 		client?.on("host-ask-unmute-audio", (payload) => {
// 			console.log(payload);
// 			setNotificationMessage("Judge asked you to unmute");
// 		});

// 		client?.on("peer-video-state-change", async (event) => {
// 			try {
// 				if (event.action === "Start") {
// 					await addVideo(event.userId);
// 				}

// 				if (event.action === "Stop") {
// 					await removeVideo(event.userId);
// 				}
// 			} catch (error) {
// 				console.log(error);
// 			}
// 		});

// 		client?.on("video-active-change", (payload) => {
// 			console.log("Active speaker, use for CSS visuals", payload.state);
// 			if (payload.state === "Active") {
// 				const allParticipants = client?.getAllUser();
// 				const validParticipants = allParticipants.filter(
// 					(p) => !p.displayName.startsWith("public-")
// 				);

// 				const participantIndex = validParticipants?.findIndex(
// 					(pt) => pt.userId === payload.userId
// 				);

// 				if (participantIndex === -1) {
// 					return;
// 				}

// 				const [activeParticipant] = validParticipants.splice(
// 					participantIndex,
// 					1
// 				);
// 				validParticipants.unshift(activeParticipant);

// 				setParticipants(validParticipants);
// 				setActiverSpeakers((prev) => {
// 					const newD = [...prev];
// 					newD.push(payload.userId);
// 					return newD;
// 				});
// 			}

// 			if (payload.state === "Inactive") {
// 				setActiverSpeakers((prev) => {
// 					return prev.filter((d) => d !== payload.userId);
// 				});
// 			}
// 		});

// 		client?.on("user-updated", (payload) => {
// 			console.log(payload[0]?.userId + " properties were updated");
// 			const allParticipants = client?.getAllUser();
// 			const validParticipants = allParticipants.filter(
// 				(p) => !p.displayName.startsWith("public-")
// 			);
// 			setParticipants(validParticipants);
// 		});

// 		client?.on("passively-stop-share", () => {
// 			const currentUserInfo = client?.getCurrentUserInfo();
// 			if (currentUserInfo) {
// 				stopScreenShare(currentUserInfo?.userId);
// 				setIsShareScreen(false);
// 				setScreenShareActive((prev) => ({ ...prev, active: false }));
// 			}
// 		});
// 	};

// 	useEffect(() => {
// 		console.log(participants);
// 		participants.forEach((p) => {
// 			if (p.bVideoOn) {
// 				addVideo(p.userId);
// 			}
// 		});
// 	}, [participants]);

// 	const toggleAudio = async () => {
// 		try {
// 			if (isAudioMuted) {
// 				await mediaStream?.unmuteAudio();
// 				setIsAudioMuted(false);
// 			} else {
// 				await mediaStream?.muteAudio();
// 				setIsAudioMuted(true);
// 			}
// 		} catch (error) {
// 			console.log(error);
// 		}
// 	};

// 	const showMoreModal = async () => {
// 		setIsMoreModalOpen(true);
// 	};

// 	const closeMoreModal = () => {
// 		setIsMoreModalOpen(false);
// 	};

// 	const showActionModal = (
// 		participant: Participant,
// 		buttonRef: React.RefObject<HTMLButtonElement>
// 	) => {
// 		if (buttonRef.current) {
// 			const rect = buttonRef.current.getBoundingClientRect();
// 			setModalPosition({ middle: rect.bottom, right: rect.left });
// 		}
// 		setSelectedParticipant(participant); // Set the selected participant
// 		setIsActionModalOpen(true);
// 	};

// 	const closeActionModal = () => {
// 		setIsActionModalOpen(false);
// 	};

// 	//function to show participant modal
// 	const showParticipantsModal = async () => {
// 		setIsParticipantsModalOpen(true);
// 		fetchParticipants();
// 	};

// 	const takeOat = async () => {
// 		setIsOatModalOpen(true);
// 	};

// 	const closeOatModal = () => {
// 		setIsOatModalOpen(false);
// 	};
// 	// Function to fetch participants
// 	const fetchParticipants = () => {
// 		if (client) {
// 			const allParticipants = client.getAllUser();
// 			if (allParticipants) {
// 				const participantsWithMuteStatus = allParticipants.map(
// 					(participant) => ({
// 						...participant,
// 						isMuted: participant.muted,
// 					})
// 				);
// 				return participantsWithMuteStatus;
// 			}
// 		}
// 	};

// 	const toggleMuteUser = async () => {
// 		if (selectedParticipant) {
// 			try {
// 				if (selectedParticipant.muted) {
// 					await mediaStream?.unmuteAudio(selectedParticipant.userId);
// 				} else {
// 					await mediaStream?.muteAudio(selectedParticipant.userId);
// 				}
// 			} catch (error) {
// 				console.error("Error muting/unmuting participant:", error);
// 			}
// 		}
// 	};

// 	const kickOutUser = async () => {
// 		if (selectedParticipant) {
// 			try {
// 				await client?.removeUser(selectedParticipant.userId);
// 				console.log(`${selectedParticipant.displayName} has been kicked out.`);
// 			} catch (error) {
// 				console.error("Error kicking out participant:", error);
// 			}
// 		}
// 	};

// 	// Function to close participant modal
// 	const closeParticipantsModal = () => {
// 		setIsParticipantsModalOpen(false);
// 	};

// 	const endOrLeaveSession = async () => {
// 		if (!forPublic) {
// 		  socket.current?.disconnect();
	  
// 		  // Stop media stream tracks safely
// 		  if (currentUser?.bVideoOn) {
// 			await mediaStream!.stopVideo();
// 		  }
// 		  if (currentUser?.audio){
// 			await mediaStream!.stopAudio();
// 		  }
// 		  mic.current?.stop();
// 		}
	  
// 		const endpoint = "https://backend-kyw8.onrender.com/session/end";
// 		const authToken = sessionStorage.getItem("token");
	  
// 		const isHost = currentUserRole === "JUDGE";
	  
// 		if (!authToken) {
// 		  navigate("/login");
// 		  return;
// 		}
	  
// 		try {
// 		  setIsLoading(true);
	  
// 		  if (isHost) {
// 			const response = await fetch(endpoint, {
// 			  method: "POST",
// 			  headers: {
// 				"Content-Type": "application/json",
// 				Authorization: `Bearer ${authToken}`,
// 			  },
// 			  body: JSON.stringify({ caseId }),
// 			});
	  
// 			const data = await response.json();
	  
// 			if (response.ok) {
// 			  console.log(data.message);
// 			  client?.leave(true);
// 			  ZoomVideo.destroyClient();
// 			  setIsSessionActive(false);
// 			  navigate(`/dashboard/case-details/${caseId}`, {
// 				state: { id: caseId },
// 			  });
// 			} else {
// 			  console.error(data.error || "Failed to end the session.");
// 			}
// 		} else {
// 			client?.leave();
// 			ZoomVideo.destroyClient();
// 			setIsSessionActive(false);
	  
// 			const destination = !forPublic
// 			  ? `/dashboard/case-details/${caseId}`
// 			  : "/";
// 			navigate(destination, {
// 			  state: { id: caseId },
// 			});
// 		}
// 		} catch (error) {
// 		  console.error("An error occurred while ending the session:", error);
// 		} finally {
// 		  setIsLoading(false);
// 		}
// 	};
	  

// 	const handleCaseDetail = () => {
// 		const caseDetailsUrl = `https://trans-legal-technologies.vercel.app/dashboard/case-details/${caseId}`;
// 		window.open(caseDetailsUrl, "_blank");
// 	};

// 	const handleSwearByQuran = async () => {
// 		setNotificationMessage("user is swearing by Quran");
// 		// await mediaStream?.updateVirtualBackgroundImage(the);
// 		setIsOatModalOpen(false);
// 	};

// 	const handleSwearByBible = async () => {
// 		setNotificationMessage("user is swearing by Bible");
// 		// await mediaStream?.updateVirtualBackgroundImage(the);
// 		setIsOatModalOpen(false);
// 	};

// 	const endOatTaking = async () => {
// 		console.log("oat taking has ended");
// 		setNotificationMessage("Witness has finished Oath Taking");
// 		await mediaStream?.updateVirtualBackgroundImage(undefined);
// 		setIsOatModalOpen(false);
// 	};

// 	const toggleScreenShare = async () => {
// 		if (!isShareScreen) {
// 			const allParticipants = client?.getAllUser();

// 			const userSharing = allParticipants?.some((p) => p.sharerOn === true);

// 			if (userSharing) {
// 				toast.error("Another user is sharing!", {
// 					position: "top-right",
// 				});
// 				return;
// 			}

// 			setIsShareScreen(true);
// 		} else {
// 			setIsShareScreen(false);
// 		}
// 	};

// 	const setupVC = async function () {
// 		if (mediaStream && client) {
// 			if (!forPublic) {
// 				await mediaStream.startVideo({ originalRatio: false, hd: true }); // prompt user for video permissions
// 				await mediaStream?.startAudio(); // prompt user for audio permissions
// 			}

// 			await renderParticipantsVideo();
// 			subscribeToEvents();

// 			if (
// 				currentUserRole === "JUDGE" ||
// 				currentUserRole === "LEGAL_REGISTRAR"
// 			) {
// 				mediaStream.setSharePrivilege(3);
// 			}

// 			if (!forPublic) {
// 				socket.current.connect();
// 			}
// 		}
// 	};

// 	//Transcription
// 	const socket = useRef(
// 		io("https://backend-kyw8.onrender.com/transcribe", {
// 			autoConnect: false,
// 			extraHeaders: {
// 				case_id: caseId!,
// 				user_id: (function () {
// 					const currentUser = client?.getCurrentUserInfo();
// 					if (currentUser) {
// 						return currentUser?.displayName;
// 					} else {
// 						return "";
// 					}
// 				})(),
// 			},
// 		})
// 	);

// 	const mic = useRef<MediaRecorder>();

// 	socket.current.on("connect", async () => {
// 		if (!alreadyOpenedMic.current) {
// 			alreadyOpenedMic.current = true;
// 			await getMicrophone();
// 			await openMicrophone(socket.current);
// 		}
// 	});

// 	socket.current.on("disconnect", () => {
// 		cleanupAudio();
// 	});
	

// 	function cleanupAudio() {
// 		if (processor.current) {
// 			processor.current.disconnect();
// 			processor.current.onaudioprocess = null;
// 		}
// 		if (input.current) {
// 			input.current.disconnect();
// 		}
// 		if (audioContext.current) {
// 			audioContext.current.close();
// 		}
	
// 		currentStream.current?.getTracks().forEach(track => track.stop());
	
// 		processor.current = null;
// 		input.current = null;
// 		audioContext.current = null;
// 		currentStream.current = null;
// 		alreadyOpenedMic.current = false;
// 	}
	

// 	const currentStream = useRef<MediaStream | null>(null);

// 	async function getMicrophone() {
// 		const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
// 		currentStream.current = stream;
	
// 		audioContext.current = new AudioContext({ sampleRate: 16000 }); // or 44100 if needed
// 		input.current = audioContext.current.createMediaStreamSource(stream);
	
// 		processor.current = audioContext.current.createScriptProcessor(4096, 1, 1);
// 		input.current.connect(processor.current);
// 		processor.current.connect(audioContext.current.destination);
// 	}
	

// 	async function openMicrophone(socket: Socket) {
// 		const currentUser = client?.getCurrentUserInfo();
	
// 		if (!processor.current) return;
	
// 		processor.current.onaudioprocess = (e) => {
// 			const floatData = e.inputBuffer.getChannelData(0); // mono
	
// 			// Convert float PCM (-1 to 1) to 16-bit PCM
// 			const int16Buffer = float32ToInt16(floatData);
	
// 			if (socket.connected) {
// 				socket.emit("audioData", int16Buffer.buffer, currentUser?.displayName);
// 			}
// 		};
// 	}
	
// 	function float32ToInt16(buffer: Float32Array) {
// 		const l = buffer.length;
// 		const int16Buffer = new Int16Array(l);
// 		for (let i = 0; i < l; i++) {
// 			const s = Math.max(-1, Math.min(1, buffer[i]));
// 			int16Buffer[i] = s < 0 ? s * 0x8000 : s * 0x7fff;
// 		}
// 		return int16Buffer;
// 	}
	
	

// 	const getRandomColor = (input: string ) => {
// 		let hash = 0;
// 		for (let i = 0; i < input.length; i++) {
// 		  hash = input.charCodeAt(i) + ((hash << 5) - hash);
// 		}
// 		const hue = hash % 360; // Limit the hue to 0-360
// 		return `hsl(${hue}, 70%, 50%)`; // Use HSL for vibrant colors
// 	};

// 	useEffect(() => {
// 		setupVC();
// 	}, []);

// 	useEffect(() => {
// 		if (isShareScreen) {
// 			renderCurrentUserScreenShare().then((element) => {
// 				setScreenShareActive({
// 					active: true,
// 					forMe: true,
// 					element: () => element,
// 				});
// 			});
// 		} else {
// 			const currentUserInfo = client?.getCurrentUserInfo();
// 			mediaStream?.stopShareScreen();
// 			stopScreenShare(currentUserInfo!.userId);
// 			setScreenShareActive((prev) => ({ ...prev, active: false }));
// 		}
// 	}, [isShareScreen]);

// 	const dummyParticipants = [1, 2];
// 	const numberOfparticipants = participants.length;

// 	const getInitials = (name: string) => {
// 		return name
// 		  ?.split(' ')
// 		  .filter(word => word.length > 0) // Remove empty spaces
// 		  .map(word => word.charAt(0))
// 		  .join('')
// 		  .toUpperCase();
// 	};

// 	const isThreeParticipants = numberOfparticipants === 3;
// 	const isFiveParticipants = numberOfparticipants === 5;
// 	const isSixParticipants = numberOfparticipants === 6;

// 	let videoContainerClass = "h-full grid grid-cols-2 col-span-1 gap-3";

// 	if (numberOfparticipants < 3 && screenShareActive.active) {
// 		videoContainerClass = `${videoContainerClass} !grid-cols-1`;
// 	}

// 	if (numberOfparticipants < 2 && !screenShareActive.active) {
// 		videoContainerClass = `${videoContainerClass} !grid-cols-1`;
// 	}

// 	if (isThreeParticipants) {
// 		videoContainerClass = `${videoContainerClass} !grid-cols-2`;
// 	}

// 	if (isFiveParticipants) {
// 		videoContainerClass = `${videoContainerClass} ${screenShareActive.active ? "!grid-cols-8" : "!grid-cols-6"}`;
// 	}

// 	// FIXED: Ensured six participants have a proper layout
// 	if (isSixParticipants) {
// 		videoContainerClass = `${videoContainerClass} ${screenShareActive.active ? "!grid-cols-2" : "!grid-cols-3"}`;
// 	}

// 	return (
// 		<div
// 			onMouseMove={() => {
// 				setShowControls(true);
// 				clearTimeout(controlsTimeoutId);
// 				controlsTimeoutId = setTimeout(() => {
// 					setShowControls(false);
// 				}, 5000);
// 			}}
// 			className="video-container w-full relative"
// 		>
// 			<OathAlertComponent />
// 			<ObjectionAlert />
// 			<video-player-container
// 				style={{
// 					height: "100vh",
// 					width: "100%",
// 					position: "relative",
// 					display: "flex",
// 					flexDirection: "column",
// 					overflow: "hidden",
// 				}}
// 			>
// 				<p
// 					className={`fixed top-5 right-5 bg-black text-white px-4 py-2 rounded-lg shadow-lg 
// 						transition-all duration-300 ease-in-out transform ${
// 							notificationMessage ? "opacity-100 scale-100" : "opacity-0 scale-95"
// 						}`}
// 				>
// 					{notificationMessage}
// 				</p>

// 				<div className={`w-full h-full grid ${screenShareActive.active ? "grid-cols-2 gap-3" : "grid-cols"} bg-[#222222]`}>
// 					{screenShareActive.active && (
// 						<ScreenshareContainer
// 							element={screenShareActive.element ? screenShareActive.element() : undefined}
// 						/>
// 					)}

// 					{/* 3-4p = cols-2 */}
// 					<div className={videoContainerClass}>
// 						{participants.slice(0, 6).map((d, i, arr) => {
// 							let classname =
// 								"flex flex-col w-full h-full bg-[#222222] overflow-hidden border-white border-[1.5px]";

// 							if (!screenShareActive.active && isThreeParticipants) {
// 								if (i === 0) classname = `${classname} row-span-2`;
// 								if (i === 1) classname = `${classname} row-span-1`;
// 							}

// 							if (screenShareActive.active && isThreeParticipants && i === 0) {
// 								classname = `${classname} col-span-2`;
// 							}

// 							if (isFiveParticipants) {
// 								if (!screenShareActive.active) {
// 									if (i < 2) classname = `${classname} col-span-3`;
// 									else classname = `${classname} col-span-2`;
// 								} else {
// 									if (i === 0) classname = `${classname} col-span-8`;
// 									else classname = `${classname} col-span-4`;
// 								}
// 							}

// 							// FIXED: Ensured six participants are assigned correctly
// 							if (isSixParticipants) {
// 								if (!screenShareActive.active) {
// 									classname = `${classname} col-span-3`;
// 								} else {
// 									classname = `${classname} col-span-2`;
// 								}
// 							}

// 							return (
// 								// eslint-disable-next-line react/jsx-key
// 								<div className={classname}>
// 									<div className="relative shrink-0">
// 										<div
// 											className={`z-[99999] ${
// 												activeSpeakers.includes(d.userId) ? "animate-ping" : ""
// 											} absolute top-[20px] right-[15px] w-[35px] h-[35px] bg-[#9B111E60] rounded-full flex items-center justify-center`}>
// 											{d.muted ? <AudioMutedOutlined /> : <AudioOutlined />}
// 										</div>
// 									</div>
// 									<div className="grow flex items-center justify-center">
// 										{d.bVideoOn && (
// 											<video-player
// 												node-id={d.userId}
// 												data-user-video={d.userId}
// 												media-type="video"
// 												style={{ display: "block" }}>
// 											</video-player>
// 										)}
// 										{!d.bVideoOn && (
// 											<div 
// 												data-user-video={d.userId}
// 												className="relative flex items-center justify-center w-24 h-24 text-white font-bold text-3xl rounded-full shadow-md"
// 												style={{ backgroundColor: getRandomColor(d.displayName || "User") }}
// 											>
// 												{/* Animated Border Effect */}
// 												{activeSpeakers.includes(d.userId) && (
// 												<div className="absolute inset-0 w-full h-full rounded-full border-4 animate-ping-fast" style={{borderColor: getRandomColor(d.displayName || 'User')}}></div>
// 												)}

// 												{/* User Initials */}
// 												<span className="relative z-10">{getInitials(d.displayName || "User")}</span>
// 											</div>
// 										)}
// 									</div>
// 								</div>
// 							);
// 						})}
// 					</div>
// 				</div>

// 				{/* Chat Interface */}
// 				{isChatOpen && (
// 					<ChatInterface
// 						toggleChat={toggleChat}
// 						isChatOpen={isChatOpen}
// 						setIsChatOpen={setIsChatOpen}
// 					/>
// 				)}
// 			</video-player-container>

// 			<div
// 				className={`video-controls ${
// 					showControls ? "flex" : "hidden"
// 				} w-full h-[10vh] bg-[#222222] p-4 justify-around fixed bottom-0`}>
// 					<div className="flex gap-2 text-white text-sm items-center">
// 						<div>{time}</div>
// 						<div className="border-l border-white h-4"></div>
// 						<div>{sessionName}</div>
// 					</div>
// 					<div className="flex gap-2 justify-center">
// 						{!forPublic && (
// 							<>
// 								{/* Oath taking Component */}
// 								<OathTaking caseId={caseId} currentUserRole={currentUserRole} isSessionActive={isSessionActive} oathRoles={oathRoles}/>
// 								{/* <BuzzerComponent /> */}
// 								<BuzzerComponent caseId={caseId} isSessionActive={isSessionActive} currentUserRole={currentUserRole} />
// 								<Tooltip title={isAudioMuted ? "unmute" : "mute"}>
// 									<Button
// 										icon={isAudioMuted ? <AudioMutedOutlined /> : <AudioOutlined />}
// 										onClick={toggleAudio}
// 										onTouchStart={toggleAudio}
// 										style={{
// 										backgroundColor: isAudioMuted ? "#28a745" : "#888",
// 										color: "#fff",
// 										borderRadius: "8px",
// 										borderColor: "#222",
// 										padding: "10px",
// 										}}
// 									/>
// 								</Tooltip>
// 								{/* {currentUserRole === "JUDGE" && (
// 									<Tooltip title={"Record Session"}>
// 										<button className="text-white">
// 											<PlayCircleIcon className="h-6 w-6" />
// 										</button>
// 									</Tooltip>
// 								)} */}
// 								{isVideooff ? (
// 									<Tooltip title="Turn Video On">
// 										<Button
// 										icon={<VideoCameraAddOutlined />}
// 										onClick={() => onVideo(currentUser!.userId)}
// 										onTouchStart={() => onVideo(currentUser!.userId)}
// 										style={{
// 											backgroundColor: "#888",
// 											color: "#fff",
// 											borderRadius: "8px",
// 											borderColor: "#222",
// 											padding: "10px",
// 										}}
// 										/>
// 									</Tooltip>
// 									) : (
// 									<Tooltip title="Turn Video Off">
// 										<Button
// 										icon={<VideoCameraFilled />}
// 										onClick={() => offVideo(currentUser!.userId)}
// 										onTouchStart={() => offVideo(currentUser!.userId)}
// 										style={{
// 											backgroundColor: "#28a745",
// 											color: "#fff",
// 											borderRadius: "8px",
// 											borderColor: "#222",
// 											padding: "10px",
// 										}}
// 										/>
// 									</Tooltip>
// 								)}
// 								{/* <Tooltip title={"Chat"}>
// 									<Button icon={<MessageFilled />} onClick={toggleChat} />
// 								</Tooltip> */}
// 								<Tooltip title={isShareScreen ? "Stop Share Screen" : "Share Screen"}>
// 									<Button
// 										icon={isShareScreen ? <FullscreenExitOutlined /> : <DesktopOutlined />}
// 										onClick={toggleScreenShare}
// 										style={{
// 										backgroundColor: isShareScreen ? "#007bff" : "#dc3545",
// 										color: "#fff",
// 										borderRadius: "8px",
// 										borderColor: "#222",
// 										padding: "10px",
// 										}}
// 									/>
// 								</Tooltip>

// 								<Tooltip title="More Options">
// 									<Button
// 										icon={<MoreOutlined />}
// 										onClick={showMoreModal}
// 										style={{
// 										backgroundColor: "#6c757d",
// 										color: "#fff",
// 										borderRadius: "8px",
// 										borderColor: "#222",
// 										padding: "10px",
// 										}}
// 									/>
// 								</Tooltip>
// 								{/* <Tooltip title="Show Participants">
// 									<Button icon={<UserOutlined />} onClick={showParticipantsModal} />
// 								</Tooltip> */}
// 							</>
// 						)}
// 						<Tooltip title={currentUserRole === "JUDGE" ? "End Session" : "Leave Session"}>
// 							<Button
// 								icon={<PhoneOutlined />}
// 								style={{
// 									backgroundColor: "red",
// 									color: "#fff",
// 									borderRadius: "40%",
// 									padding: "10px",
// 									borderColor: "#222",
// 									width: "40px",
// 								}}
// 								onClick={endOrLeaveSession}
// 								onTouchStart={endOrLeaveSession}
// 								disabled={isLoading}
// 							/>
// 						</Tooltip>
// 					</div>
// 					{(!forPublic &&
// 						<div className="flex gap-2">
// 							{currentUserRole === "JUDGE" && (
// 								<Tooltip title={"Record Session"}>
// 									<Button className="text-white"
// 									icon={isRecording ? <StopOutlined /> : <div className="w-4 h-4 bg-red-500 rounded-full"></div>}
// 									style={{
// 										backgroundColor: isRecording ? "#dc3545" : "#444",
// 										color: "#fff",
// 										borderRadius: "8px",
// 										padding: "10px",
// 									  }}
// 									/>
// 								</Tooltip>
// 							)}
// 							<Tooltip title={"Chat"}>
// 								<Button icon={<MessageFilled />} onClick={toggleChat} 
// 									style={{
// 										backgroundColor: "#6c757d",
// 										color: "#fff",
// 										borderRadius: "8px",
// 										borderColor: "#222",
// 										padding: "10px",
// 									}}
// 								/>
// 							</Tooltip>
// 							<Tooltip title="Show Participants">
// 								<Button icon={<UserOutlined />} onClick={showParticipantsModal}
// 									style={{
// 										backgroundColor: "#6c757d",
// 										color: "#fff",
// 										borderRadius: "8px",
// 										borderColor: "#222",
// 										padding: "10px",
// 									}}
// 								/>
// 							</Tooltip>
// 						</div>
// 					)}

// 				<Modal
// 					title=""
// 					open={isMoreModalOpen}
// 					onCancel={closeMoreModal}
// 					footer={[
// 						<Button key="close" onClick={closeMoreModal}>
// 							Close
// 						</Button>,
// 					]}>
// 					<div className="flex flex-col gap-3 mt-10 pl-5">
// 						<button
// 							className="flex justify-left font-bold"
// 							onClick={handleCaseDetail}>
// 							View Case Details
// 						</button>
// 						<EvidenceList />
// 						{currentUserRole === "COUNSEL" && <UploadEvidence />}
// 					</div>
// 				</Modal>
// 				<Modal
// 					title="Participants"
// 					open={isParticipantsModalOpen}
// 					onCancel={closeParticipantsModal}
// 					footer={[
// 						<Button key="close" onClick={closeParticipantsModal}>
// 							Close
// 						</Button>,
// 					]}>
// 					{/* Displaying list of participants */}
// 					<List
// 						itemLayout="horizontal"
// 						dataSource={participants}
// 						renderItem={(participant: Participant) => (
// 							<List.Item>
// 								<List.Item.Meta
// 									title={
// 										<div className="flex justify-between">
// 											<div style={{ display: "flex", alignItems: "center" }}>
// 												{participant.displayName}
// 												{participant.muted ? (
// 													<AudioMutedOutlined
// 														style={{ marginLeft: "8px", color: "red" }}
// 													/>
// 												) : (
// 													<AudioOutlined
// 														style={{ marginLeft: "8px", color: "green" }}
// 													/>
// 												)}
// 											</div>
// 											{currentUser?.isHost && (
// 												<div>
// 													<Button
// 														icon={<MoreOutlined />}
// 														onClick={() =>
// 															showActionModal(
// 																participant,
// 																moreButtonRefs.current[participant.userId]
// 															)
// 														}
// 														ref={moreButtonRefs.current[participant.userId]}
// 													/>
// 													{selectedParticipant && (
// 														<Modal
// 															title=""
// 															className="w-fit"
// 															open={isActionModalOpen}
// 															onCancel={closeActionModal}
// 															footer={[
// 																<Button key="close" onClick={closeActionModal}>
// 																	Close
// 																</Button>,
// 															]}
// 															style={{
// 																position: "absolute",
// 																top: modalPosition.middle,
// 																left: modalPosition.right,
// 															}}
// 															getContainer={false}>
// 															<div className="flex flex-col gap-2">
// 																<Button
// 																	onClick={toggleMuteUser}
// 																	className="w-fit text-left">
// 																	{selectedParticipant.muted
// 																		? "Unmute"
// 																		: "Mute"}
// 																</Button>
// 																{!selectedParticipant.isHost && (
// 																	<Button
// 																		onClick={kickOutUser}
// 																		className="w-fit text-left">
// 																		Kick out {selectedParticipant.displayName}
// 																	</Button>
// 																)}
// 															</div>
// 														</Modal>
// 													)}
// 												</div>
// 											)}
// 										</div>
// 									}
// 								/>
// 							</List.Item>
// 						)}
// 					/>
// 				</Modal>
// 			</div>
// 		</div>
// 	);
// };

// export default VideoContainer;

import React, { useContext, useEffect, useState, useRef, useCallback } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import zoomContext from "../../Contexts/zoom-context";
import mediaContext from "../../Contexts/media-context";
import ZoomVideo, { VideoQuality } from "@zoom/videosdk";
import ChatInterface from "./chatInterface";
import BuzzerComponent from "./buzzer";
import io, { Socket } from "socket.io-client";
import { Button, Modal, List, Tooltip } from "antd";
import ObjectionAlert from "./objectionAlert";
// import { PlayCircleIcon } from "@heroicons/react/24/outline";
import {
	AudioMutedOutlined,
	AudioOutlined,
	VideoCameraAddOutlined,
	VideoCameraFilled,
	FullscreenExitOutlined,
	// FullscreenOutlined,
	DesktopOutlined,
	PhoneOutlined,
	MessageFilled,
	StopOutlined,
	// BookOutlined,
	UserOutlined,
	MoreOutlined,
	// BookFilled,
} from "@ant-design/icons";
import { Participant } from "@/src/index-types";
import UploadEvidence from "./uploadEvidence";
import EvidenceList from "./evidenceList";
import ScreenshareContainer from "./ScreenshareContainer";
import { toast } from "react-toastify";
import OathAlertComponent from "./oatTakingAlert";
import OathTaking from "./oat";

// let alreadyOpenedMic = false;
let controlsTimeoutId: any;

interface VideoContainerProps {
	currentUserRole: any;
	sessionName: any;
	setIsSessionActive: React.Dispatch<React.SetStateAction<boolean>>;
	isSessionActive: boolean;
	forPublic?: boolean;
}

const VideoContainer: React.FC<VideoContainerProps> = ({
	currentUserRole,
	setIsSessionActive,
	sessionName,
	isSessionActive,
	forPublic,
}) => {
	const mediaStream = useContext(mediaContext);
	const client = useContext(zoomContext);
	const navigate = useNavigate();
	const location = useLocation();
	const params = location.state || {};
	const { id: caseId } = params;
	const [notificationMessage, setNotificationMessage] = useState("");
	const [isShareScreen, setIsShareScreen] = useState(false);
	const [isVideooff, setIsVideoOff] = useState(false);
	const [isAudioMuted, setIsAudioMuted] = useState(false);
	const [isParticipantsModalOpen, setIsParticipantsModalOpen] = useState(false);
	const [isMoreModalOpen, setIsMoreModalOpen] = useState(false);
	const [isActionModalOpen, setIsActionModalOpen] = useState(false);
	// eslint-disable-next-line @typescript-eslint/no-unused-vars
	const [isOatModalOpen, setIsOatModalOpen] = useState(false);
	const [participants, setParticipants] = useState<Array<Participant>>([]);
	const [selectedParticipant, setSelectedParticipant] =
		useState<Participant | null>(null);
	const [isChatOpen, setIsChatOpen] = useState(false);
	const currentUser = client?.getCurrentUserInfo();
	const [modalPosition, setModalPosition] = useState({
		middle: 100,
		right: 800,
	});
	// eslint-disable-next-line @typescript-eslint/no-unused-vars
	const [isRecording, setIsRecording ] = useState(false)
	// eslint-disable-next-line @typescript-eslint/no-unused-vars
	const [time, setTime] = useState(new Date().toLocaleTimeString());
	const moreButtonRefs = useRef<
		Record<string, React.RefObject<HTMLButtonElement>>
	>({});
	const [isLoading, setIsLoading] = useState(false);

	const [screenShareActive, setScreenShareActive] = useState<{
		active: boolean;
		forMe: boolean;
		element:
			| (() => HTMLVideoElement | HTMLCanvasElement | undefined)
			| undefined;
	}>({
		active: false,
		forMe: true,
		element: undefined,
	});

	const [showControls, setShowControls] = useState(true);

	const [activeSpeakers, setActiverSpeakers] = useState<number[]>([]);

	const toggleChat = () => {
		setIsChatOpen(!isChatOpen);
	};
	const oathRoles = ["WITNESS", "COUNSEL", "CLAIMANT", "DEFENDANT"];

	const audioContext = useRef<AudioContext | null>(null);
	const processor = useRef<ScriptProcessorNode | null>(null);
	const input = useRef<MediaStreamAudioSourceNode | null>(null);
	const alreadyOpenedMic = useRef(false);

	useEffect(() => {
		participants.forEach((participant) => {
			if (!moreButtonRefs.current[participant.userId]) {
				moreButtonRefs.current[participant.userId] = React.createRef();
			}
		});
	}, [participants]);

	const getScreenShareElement = useCallback(
		(useVideo: (() => boolean) | undefined ) => {
		let element: HTMLVideoElement | HTMLCanvasElement;
		if (useVideo) {
			element = document.createElement("video");
			element.className = "w-full h-auto";
			element.setAttribute("height", "1080");
		} else {
			element = document.createElement("canvas");
			element.className = "w-full h-auto";
			element.setAttribute("width", "1920");
		}

		return element;
	}, [])

	const renderCurrentUserScreenShare = useCallback(
		async () => {
		try {
			const useVideo = mediaStream?.isStartShareScreenWithVideoElement;
			const element = getScreenShareElement(useVideo!);
			const currentUserInfo = client?.getCurrentUserInfo();

			// Check if element is valid and start screen share
			if (element && currentUserInfo) {
				await mediaStream?.startShareScreen(element);

				// Add user-specific data attribute
				element.setAttribute(
					"data-user-canvas",
					String(currentUserInfo.userId)
				);

				return element;
			}
		} catch (error) {
			console.error("Error in renderCurrentUserScreenShare:", error);
		}
	},[client, getScreenShareElement, mediaStream])

	const renderParticipantScreenShare = useCallback(
		async (userId) => {
		try {
			const canvasElement = document.createElement("canvas");
			canvasElement.setAttribute("data-user-canvas", String(userId));

			// Start sharing the participant's screen
			await mediaStream?.startShareView(canvasElement, userId);

			return canvasElement;
		} catch (error) {
			console.error("Error in renderParticipantScreenShare:", error);
		}
	}, [mediaStream])

	const stopScreenShare = async (userId: any) => {
		try {
			const elementToRemove = document.querySelector(
				`[data-user-canvas="${userId}"]`
			);
			if (elementToRemove) {
				elementToRemove.remove();
			} else {
				console.log(`No screen share found for user ${userId}`);
			}
		} catch (error) {
			console.error("Error in stopScreenShare:", error);
		}
	}

	const removeVideo = useCallback(
		async (userId: number) => {
		await mediaStream?.detachVideo(userId);
		// document.querySelector(`[data-user-video="${userId}"]`)?.remove();
		// setParticipants((prev) => prev.filter((p) => p.userId !== userId));
	}, [mediaStream])
	const addVideo = useCallback(
		async (userId: number) => {
		await mediaStream?.attachVideo(userId, VideoQuality.Video_720P);
		// document.querySelector(`[data-user-video="${userId}"]`)?.remove();
		// setParticipants((prev) => prev.filter((p) => p.userId !== userId));
	},[mediaStream])

	async function offVideo(userId: number) {
		await mediaStream?.stopVideo();
		await mediaStream?.detachVideo(userId);
		setIsVideoOff(true)
	}
	async function onVideo(userId: number) {
		await mediaStream?.startVideo();
		await mediaStream?.attachVideo(userId, VideoQuality.Video_720P);
		setIsVideoOff(false)
		// document.querySelector(`[data-user-video="${userId}"]`)?.remove();
		// setParticipants((prev) => prev.filter((p) => p.userId !== userId));
	}

		const fetchParticipants = useCallback(
			() => {
		if (client) {
			const allParticipants = client.getAllUser();
			if (allParticipants) {
				const participantsWithMuteStatus = allParticipants.map(
					(participant) => ({
						...participant,
						isMuted: participant.muted,
					})
				);
				return participantsWithMuteStatus;
			}
		}
	},[client])

	const renderParticipantsVideo = useCallback(
		async () => {
		const allParticipants = fetchParticipants();
		const newParticipants: Array<Participant> = [];

		try {
			allParticipants?.forEach(async (participant) => {
				if (participant.displayName.startsWith("public-")) {
					return;
				}

				if (participant.bVideoOn) {
					await addVideo(participant.userId);
				}

				newParticipants.push(participant);

				console.log(participant, "render");

				if (participant.sharerOn) {
					const element = await renderParticipantScreenShare(
						participant.userId
					);
					setScreenShareActive({
						active: true,
						forMe: false,
						element: () => element,
					});
				}
			});

			setParticipants(newParticipants);
		} catch (error) {
			console.log(error);
		}
	},[addVideo, fetchParticipants, renderParticipantScreenShare])

	useEffect(() => {
		if (notificationMessage) {
			const timer = setTimeout(() => {
				setNotificationMessage("");
			}, 4000); // Clear notification after 4 seconds

			return () => clearTimeout(timer); // Clear timer on cleanup
		}
	}, [notificationMessage]);

	const subscribeToEvents = useCallback(
		function () {
		client?.on("user-added", async (payload) => {
			try {
				payload.forEach((pt) => {
					console.log(pt?.userId + " joined the session", pt);
					setNotificationMessage(pt?.displayName + " Joined the session");
				});
				const allParticipants = client?.getAllUser();
				const validParticipants = allParticipants.filter(
					(p) => !p.displayName.startsWith("public-")
				);
				setParticipants(validParticipants);
			} catch (error) {
				console.log(error);
			}
		});

		client?.on("user-removed", (payload) => {
			payload.forEach((pt) => {
				console.log(pt?.userId + " left the session");
				setNotificationMessage(pt?.displayName + " left the session");

				removeVideo(pt?.userId);
			});
			const allParticipants = client?.getAllUser();
			const validParticipants = allParticipants.filter(
				(p) => !p.displayName.startsWith("public-")
			);
			setParticipants(validParticipants);
		});

		client?.on("active-share-change", (payload) => {
			if (payload.state === "Active") {
				renderParticipantScreenShare(payload.userId).then((element) => {
					setScreenShareActive({
						active: true,
						forMe: false,
						element: () => element,
					});
				});
			} else if (payload.state === "Inactive") {
				mediaStream?.stopShareView();
				stopScreenShare(payload.userId);
				setScreenShareActive((prev) => ({ ...prev, active: false }));
			}
		});

		client?.on("connection-change", (payload) => {
			if ((payload.state === "Closed", payload.reason)) {
				// session ended by the host or the SDK kicked the user from the session (use payload.reason to see why the SDK kicked the user)
				setNotificationMessage("Connection Closed " + payload.reason);
				console.log(payload.reason);
			} else if (payload.state === "Reconnecting") {
				// the client side has lost connection with the server (like when driving through a tunnel)
				// will try to reconnect for a few minutes
				setNotificationMessage("Reconnecting...");
			} else if (payload.state === "Connected") {
				// SDK reconnected the session after a reconnecting state
				setNotificationMessage("Connected!");
			} else if (payload.state === "Fail") {
				// session failed to reconnect after a few minutes
				// user flushed from Zoom Video SDK session
				setNotificationMessage("Connection Failed!");
			}
		});

		client?.on("host-ask-unmute-audio", (payload) => {
			console.log(payload);
			setNotificationMessage("Judge asked you to unmute");
		});

		client?.on("peer-video-state-change", async (event) => {
			try {
				if (event.action === "Start") {
					await addVideo(event.userId);
				}

				if (event.action === "Stop") {
					await removeVideo(event.userId);
				}
			} catch (error) {
				console.log(error);
			}
		});

		client?.on("video-active-change", (payload) => {
			console.log("Active speaker, use for CSS visuals", payload.state);
			if (payload.state === "Active") {
				const allParticipants = client?.getAllUser();
				const validParticipants = allParticipants.filter(
					(p) => !p.displayName.startsWith("public-")
				);

				const participantIndex = validParticipants?.findIndex(
					(pt) => pt.userId === payload.userId
				);

				if (participantIndex === -1) {
					return;
				}

				const [activeParticipant] = validParticipants.splice(
					participantIndex,
					1
				);
				validParticipants.unshift(activeParticipant);

				setParticipants(validParticipants);
				setActiverSpeakers((prev) => {
					const newD = [...prev];
					newD.push(payload.userId);
					return newD;
				});
			}

			if (payload.state === "Inactive") {
				setActiverSpeakers((prev) => {
					return prev.filter((d) => d !== payload.userId);
				});
			}
		});

		client?.on("user-updated", (payload) => {
			console.log(payload[0]?.userId + " properties were updated");
			const allParticipants = client?.getAllUser();
			const validParticipants = allParticipants.filter(
				(p) => !p.displayName.startsWith("public-")
			);
			setParticipants(validParticipants);
		});

		client?.on("passively-stop-share", () => {
			const currentUserInfo = client?.getCurrentUserInfo();
			if (currentUserInfo) {
				stopScreenShare(currentUserInfo?.userId);
				setIsShareScreen(false);
				setScreenShareActive((prev) => ({ ...prev, active: false }));
			}
		});
	}, [addVideo, client, mediaStream, removeVideo, renderParticipantScreenShare]
	)

	useEffect(() => {
		console.log(participants);
		participants.forEach((p) => {
			if (p.bVideoOn) {
				addVideo(p.userId);
			}
		});
	}, [addVideo, participants]);

	const toggleAudio = async () => {
		try {
			if (isAudioMuted) {
				await mediaStream?.unmuteAudio();
				setIsAudioMuted(false);
			} else {
				await mediaStream?.muteAudio();
				setIsAudioMuted(true);
			}
		} catch (error) {
			console.log(error);
		}
	};

	const showMoreModal = async () => {
		setIsMoreModalOpen(true);
	};

	const closeMoreModal = () => {
		setIsMoreModalOpen(false);
	};

	const showActionModal = (
		participant: Participant,
		buttonRef: React.RefObject<HTMLButtonElement>
	) => {
		if (buttonRef.current) {
			const rect = buttonRef.current.getBoundingClientRect();
			setModalPosition({ middle: rect.bottom, right: rect.left });
		}
		setSelectedParticipant(participant); // Set the selected participant
		setIsActionModalOpen(true);
	};

	const closeActionModal = () => {
		setIsActionModalOpen(false);
	};

	//function to show participant modal
	const showParticipantsModal = async () => {
		setIsParticipantsModalOpen(true);
		fetchParticipants();
	};
// eslint-disable-next-line @typescript-eslint/no-unused-vars
	const takeOat = async () => {
		setIsOatModalOpen(true);
	};
// eslint-disable-next-line @typescript-eslint/no-unused-vars
	const closeOatModal = () => {
		setIsOatModalOpen(false);
	};
	// Function to fetch participants

	const toggleMuteUser = async () => {
		if (selectedParticipant) {
			try {
				if (selectedParticipant.muted) {
					await mediaStream?.unmuteAudio(selectedParticipant.userId);
				} else {
					await mediaStream?.muteAudio(selectedParticipant.userId);
				}
			} catch (error) {
				console.error("Error muting/unmuting participant:", error);
			}
		}
	};

	const kickOutUser = async () => {
		if (selectedParticipant) {
			try {
				await client?.removeUser(selectedParticipant.userId);
				console.log(`${selectedParticipant.displayName} has been kicked out.`);
			} catch (error) {
				console.error("Error kicking out participant:", error);
			}
		}
	};

	// Function to close participant modal
	const closeParticipantsModal = () => {
		setIsParticipantsModalOpen(false);
	};

	const endOrLeaveSession = async () => {
		if (!forPublic) {
		  socket.current?.disconnect();
	  
		  // Stop media stream tracks safely
		  if (currentUser?.bVideoOn) {
			await mediaStream!.stopVideo();
		  }
		  if (currentUser?.audio){
			await mediaStream!.stopAudio();
		  }
		  mic.current?.stop();
		}
	  
		const endpoint = "https://backend-kyw8.onrender.com/session/end";
		const authToken = sessionStorage.getItem("token");
	  
		const isHost = currentUserRole === "JUDGE";
	  
		if (!authToken) {
		  navigate("/login");
		  return;
		}
	  
		try {
		  setIsLoading(true);
	  
		  if (isHost) {
			const response = await fetch(endpoint, {
			  method: "POST",
			  headers: {
				"Content-Type": "application/json",
				Authorization: `Bearer ${authToken}`,
			  },
			  body: JSON.stringify({ caseId }),
			});
	  
			const data = await response.json();
	  
			if (response.ok) {
			  console.log(data.message);
			  client?.leave(true);
			  ZoomVideo.destroyClient();
			  setIsSessionActive(false);
			  navigate(`/dashboard/case-details/${caseId}`, {
				state: { id: caseId },
			  });
			} else {
			  console.error(data.error || "Failed to end the session.");
			}
		} else {
			client?.leave();
			ZoomVideo.destroyClient();
			setIsSessionActive(false);
	  
			const destination = !forPublic
			  ? `/dashboard/case-details/${caseId}`
			  : "/";
			navigate(destination, {
			  state: { id: caseId },
			});
		}
		} catch (error) {
		  console.error("An error occurred while ending the session:", error);
		} finally {
		  setIsLoading(false);
		}
	};
	  

	const handleCaseDetail = () => {
		const caseDetailsUrl = `https://trans-legal-technologies.vercel.app/dashboard/case-details/${caseId}`;
		window.open(caseDetailsUrl, "_blank");
	};
// eslint-disable-next-line @typescript-eslint/no-unused-vars
	const handleSwearByQuran = async () => {
		setNotificationMessage("user is swearing by Quran");
		// await mediaStream?.updateVirtualBackgroundImage(the);
		setIsOatModalOpen(false);
	};
// eslint-disable-next-line @typescript-eslint/no-unused-vars
	const handleSwearByBible = async () => {
		setNotificationMessage("user is swearing by Bible");
		// await mediaStream?.updateVirtualBackgroundImage(the);
		setIsOatModalOpen(false);
	};
// eslint-disable-next-line @typescript-eslint/no-unused-vars
	const endOatTaking = async () => {
		console.log("oat taking has ended");
		setNotificationMessage("Witness has finished Oath Taking");
		await mediaStream?.updateVirtualBackgroundImage(undefined);
		setIsOatModalOpen(false);
	};

	const toggleScreenShare = async () => {
		if (!isShareScreen) {
			const allParticipants = client?.getAllUser();

			const userSharing = allParticipants?.some((p) => p.sharerOn === true);

			if (userSharing) {
				toast.error("Another user is sharing!", {
					position: "top-right",
				});
				return;
			}

			setIsShareScreen(true);
		} else {
			setIsShareScreen(false);
		}
	};

	const setupVC = useCallback(
		async function () {
		if (mediaStream && client) {
			if (!forPublic) {
				await mediaStream.startVideo({ originalRatio: false, hd: true }); // prompt user for video permissions
				await mediaStream?.startAudio(); // prompt user for audio permissions
			}

			await renderParticipantsVideo();
			subscribeToEvents();

			if (
				currentUserRole === "JUDGE" ||
				currentUserRole === "LEGAL_REGISTRAR"
			) {
				mediaStream.setSharePrivilege(3);
			}

			if (!forPublic) {
				socket.current.connect();
			}
		}
	},[client, currentUserRole, forPublic, mediaStream, renderParticipantsVideo, subscribeToEvents]
	)
	//Transcription
	const socket = useRef(
		io("https://backend-kyw8.onrender.com/transcribe", {
			autoConnect: false,
			extraHeaders: {
				case_id: caseId!,
				user_id: (function () {
					const currentUser = client?.getCurrentUserInfo();
					if (currentUser) {
						return currentUser?.displayName;
					} else {
						return "";
					}
				})(),
			},
		})
	);

	const mic = useRef<MediaRecorder>();

	socket.current.on("connect", async () => {
		if (!alreadyOpenedMic.current) {
			alreadyOpenedMic.current = true;
			await getMicrophone();
			await openMicrophone(socket.current);
		}
	});

	socket.current.on("disconnect", () => {
		cleanupAudio();
	});
	

	function cleanupAudio() {
		if (processor.current) {
			processor.current.disconnect();
			processor.current.onaudioprocess = null;
		}
		if (input.current) {
			input.current.disconnect();
		}
		if (audioContext.current) {
			audioContext.current.close();
		}
	
		currentStream.current?.getTracks().forEach(track => track.stop());
	
		processor.current = null;
		input.current = null;
		audioContext.current = null;
		currentStream.current = null;
		alreadyOpenedMic.current = false;
	}
	

	const currentStream = useRef<MediaStream | null>(null);

	async function getMicrophone() {
		const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
		currentStream.current = stream;
	
		audioContext.current = new AudioContext({ sampleRate: 16000 }); // or 44100 if needed
		input.current = audioContext.current.createMediaStreamSource(stream);
	
		processor.current = audioContext.current.createScriptProcessor(4096, 1, 1);
		input.current.connect(processor.current);
		processor.current.connect(audioContext.current.destination);
	}
	

	async function openMicrophone(socket: Socket) {
		const currentUser = client?.getCurrentUserInfo();
	
		if (!processor.current) return;
	
		processor.current.onaudioprocess = (e) => {
			const floatData = e.inputBuffer.getChannelData(0); // mono
	
			// Convert float PCM (-1 to 1) to 16-bit PCM
			const int16Buffer = float32ToInt16(floatData);
	
			if (socket.connected) {
				socket.emit("audioData", int16Buffer.buffer, currentUser?.displayName);
			}
		};
	}
	
	function float32ToInt16(buffer: Float32Array) {
		const l = buffer.length;
		const int16Buffer = new Int16Array(l);
		for (let i = 0; i < l; i++) {
			const s = Math.max(-1, Math.min(1, buffer[i]));
			int16Buffer[i] = s < 0 ? s * 0x8000 : s * 0x7fff;
		}
		return int16Buffer;
	}
	
	

	const getRandomColor = (input: string ) => {
		let hash = 0;
		for (let i = 0; i < input.length; i++) {
		  hash = input.charCodeAt(i) + ((hash << 5) - hash);
		}
		const hue = hash % 360; // Limit the hue to 0-360
		return `hsl(${hue}, 70%, 50%)`; // Use HSL for vibrant colors
	};

	useEffect(() => {
		setupVC();
	}, [setupVC]);

	useEffect(() => {
		if (isShareScreen) {
			renderCurrentUserScreenShare().then((element) => {
				setScreenShareActive({
					active: true,
					forMe: true,
					element: () => element,
				});
			});
		} else {
			const currentUserInfo = client?.getCurrentUserInfo();
			mediaStream?.stopShareScreen();
			stopScreenShare(currentUserInfo!.userId);
			setScreenShareActive((prev) => ({ ...prev, active: false }));
		}
	}, [client, isShareScreen, mediaStream, renderCurrentUserScreenShare]);
// eslint-disable-next-line @typescript-eslint/no-unused-vars
	const dummyParticipants = [1, 2];
	const numberOfparticipants = participants.length;

	const getInitials = (name: string) => {
		return name
		  ?.split(' ')
		  .filter(word => word.length > 0) // Remove empty spaces
		  .map(word => word.charAt(0))
		  .join('')
		  .toUpperCase();
	};

	const isThreeParticipants = numberOfparticipants === 3;
	const isFiveParticipants = numberOfparticipants === 5;
	const isSixParticipants = numberOfparticipants === 6;

	let videoContainerClass = "h-full grid grid-cols-2 col-span-1 gap-3";

	if (numberOfparticipants < 3 && screenShareActive.active) {
		videoContainerClass = `${videoContainerClass} !grid-cols-1`;
	}

	if (numberOfparticipants < 2 && !screenShareActive.active) {
		videoContainerClass = `${videoContainerClass} !grid-cols-1`;
	}

	if (isThreeParticipants) {
		videoContainerClass = `${videoContainerClass} !grid-cols-2`;
	}

	if (isFiveParticipants) {
		videoContainerClass = `${videoContainerClass} ${screenShareActive.active ? "!grid-cols-8" : "!grid-cols-6"}`;
	}

	// FIXED: Ensured six participants have a proper layout
	if (isSixParticipants) {
		videoContainerClass = `${videoContainerClass} ${screenShareActive.active ? "!grid-cols-2" : "!grid-cols-3"}`;
	}

	return (
		<div
			onMouseMove={() => {
				setShowControls(true);
				clearTimeout(controlsTimeoutId);
				controlsTimeoutId = setTimeout(() => {
					setShowControls(false);
				}, 5000);
			}}
			className="video-container w-full relative"
		>
			<OathAlertComponent />
			<ObjectionAlert />
			<video-player-container
				style={{
					height: "100vh",
					width: "100%",
					position: "relative",
					display: "flex",
					flexDirection: "column",
					overflow: "hidden",
				}}
			>
				<p
					className={`fixed top-5 right-5 bg-black text-white px-4 py-2 rounded-lg shadow-lg 
						transition-all duration-300 ease-in-out transform ${
							notificationMessage ? "opacity-100 scale-100" : "opacity-0 scale-95"
						}`}
				>
					{notificationMessage}
				</p>

				<div className={`w-full h-full grid ${screenShareActive.active ? "grid-cols-2 gap-3" : "grid-cols"} bg-[#222222]`}>
					{screenShareActive.active && (
						<ScreenshareContainer
							element={screenShareActive.element ? screenShareActive.element() : undefined}
						/>
					)}

					{/* 3-4p = cols-2 */}
					<div className={videoContainerClass}>
						{participants.slice(0, 6).map((d, i, arr) => {
							let classname =
								"flex flex-col w-full h-full bg-[#222222] overflow-hidden border-white border-[1.5px]";

							if (!screenShareActive.active && isThreeParticipants) {
								if (i === 0) classname = `${classname} row-span-2`;
								if (i === 1) classname = `${classname} row-span-1`;
							}

							if (screenShareActive.active && isThreeParticipants && i === 0) {
								classname = `${classname} col-span-2`;
							}

							if (isFiveParticipants) {
								if (!screenShareActive.active) {
									if (i < 2) classname = `${classname} col-span-3`;
									else classname = `${classname} col-span-2`;
								} else {
									if (i === 0) classname = `${classname} col-span-8`;
									else classname = `${classname} col-span-4`;
								}
							}

							// FIXED: Ensured six participants are assigned correctly
							if (isSixParticipants) {
								if (!screenShareActive.active) {
									classname = `${classname} col-span-3`;
								} else {
									classname = `${classname} col-span-2`;
								}
							}

							return (
								// eslint-disable-next-line react/jsx-key
								<div className={classname}>
									<div className="relative shrink-0">
										<div
											className={`z-[99999] ${
												activeSpeakers.includes(d.userId) ? "animate-ping" : ""
											} absolute top-[20px] right-[15px] w-[35px] h-[35px] bg-[#9B111E60] rounded-full flex items-center justify-center`}>
											{d.muted ? <AudioMutedOutlined /> : <AudioOutlined />}
										</div>
									</div>
									<div className="grow flex items-center justify-center">
										{d.bVideoOn && (
											<video-player
												node-id={d.userId}
												data-user-video={d.userId}
												media-type="video"
												style={{ display: "block" }}>
											</video-player>
										)}
										{!d.bVideoOn && (
											<div 
												data-user-video={d.userId}
												className="relative flex items-center justify-center w-24 h-24 text-white font-bold text-3xl rounded-full shadow-md"
												style={{ backgroundColor: getRandomColor(d.displayName || "User") }}
											>
												{/* Animated Border Effect */}
												{activeSpeakers.includes(d.userId) && (
												<div className="absolute inset-0 w-full h-full rounded-full border-4 animate-ping-fast" style={{borderColor: getRandomColor(d.displayName || 'User')}}></div>
												)}

												{/* User Initials */}
												<span className="relative z-10">{getInitials(d.displayName || "User")}</span>
											</div>
										)}
									</div>
								</div>
							);
						})}
					</div>
				</div>

				{/* Chat Interface */}
				{isChatOpen && (
					<ChatInterface
						toggleChat={toggleChat}
						isChatOpen={isChatOpen}
						setIsChatOpen={setIsChatOpen}
					/>
				)}
			</video-player-container>

			<div
				className={`video-controls ${
					showControls ? "flex" : "hidden"
				} w-full h-[10vh] bg-[#222222] p-4 justify-around fixed bottom-0`}>
					<div className="flex gap-2 text-white text-sm items-center">
						<div>{time}</div>
						<div className="border-l border-white h-4"></div>
						<div>{sessionName}</div>
					</div>
					<div className="flex gap-2 justify-center">
						{!forPublic && (
							<>
								{/* Oath taking Component */}
								<OathTaking caseId={caseId} currentUserRole={currentUserRole} isSessionActive={isSessionActive} oathRoles={oathRoles}/>
								{/* <BuzzerComponent /> */}
								<BuzzerComponent caseId={caseId} isSessionActive={isSessionActive} currentUserRole={currentUserRole} />
								<Tooltip title={isAudioMuted ? "unmute" : "mute"}>
									<Button
										icon={isAudioMuted ? <AudioMutedOutlined /> : <AudioOutlined />}
										onClick={toggleAudio}
										onTouchStart={toggleAudio}
										style={{
										backgroundColor: isAudioMuted ? "#28a745" : "#888",
										color: "#fff",
										borderRadius: "8px",
										borderColor: "#222",
										padding: "10px",
										}}
									/>
								</Tooltip>
								{/* {currentUserRole === "JUDGE" && (
									<Tooltip title={"Record Session"}>
										<button className="text-white">
											<PlayCircleIcon className="h-6 w-6" />
										</button>
									</Tooltip>
								)} */}
								{isVideooff ? (
									<Tooltip title="Turn Video On">
										<Button
										icon={<VideoCameraAddOutlined />}
										onClick={() => onVideo(currentUser!.userId)}
										onTouchStart={() => onVideo(currentUser!.userId)}
										style={{
											backgroundColor: "#888",
											color: "#fff",
											borderRadius: "8px",
											borderColor: "#222",
											padding: "10px",
										}}
										/>
									</Tooltip>
									) : (
									<Tooltip title="Turn Video Off">
										<Button
										icon={<VideoCameraFilled />}
										onClick={() => offVideo(currentUser!.userId)}
										onTouchStart={() => offVideo(currentUser!.userId)}
										style={{
											backgroundColor: "#28a745",
											color: "#fff",
											borderRadius: "8px",
											borderColor: "#222",
											padding: "10px",
										}}
										/>
									</Tooltip>
								)}
								{/* <Tooltip title={"Chat"}>
									<Button icon={<MessageFilled />} onClick={toggleChat} />
								</Tooltip> */}
								<Tooltip title={isShareScreen ? "Stop Share Screen" : "Share Screen"}>
									<Button
										icon={isShareScreen ? <FullscreenExitOutlined /> : <DesktopOutlined />}
										onClick={toggleScreenShare}
										style={{
										backgroundColor: isShareScreen ? "#007bff" : "#dc3545",
										color: "#fff",
										borderRadius: "8px",
										borderColor: "#222",
										padding: "10px",
										}}
									/>
								</Tooltip>

								<Tooltip title="More Options">
									<Button
										icon={<MoreOutlined />}
										onClick={showMoreModal}
										style={{
										backgroundColor: "#6c757d",
										color: "#fff",
										borderRadius: "8px",
										borderColor: "#222",
										padding: "10px",
										}}
									/>
								</Tooltip>
								{/* <Tooltip title="Show Participants">
									<Button icon={<UserOutlined />} onClick={showParticipantsModal} />
								</Tooltip> */}
							</>
						)}
						<Tooltip title={currentUserRole === "JUDGE" ? "End Session" : "Leave Session"}>
							<Button
								icon={<PhoneOutlined />}
								style={{
									backgroundColor: "red",
									color: "#fff",
									borderRadius: "40%",
									padding: "10px",
									borderColor: "#222",
									width: "40px",
								}}
								onClick={endOrLeaveSession}
								onTouchStart={endOrLeaveSession}
								disabled={isLoading}
							/>
						</Tooltip>
					</div>
					{(!forPublic &&
						<div className="flex gap-2">
							{currentUserRole === "JUDGE" && (
								<Tooltip title={"Record Session"}>
									<Button className="text-white"
									icon={isRecording ? <StopOutlined /> : <div className="w-4 h-4 bg-red-500 rounded-full"></div>}
									style={{
										backgroundColor: isRecording ? "#dc3545" : "#444",
										color: "#fff",
										borderRadius: "8px",
										padding: "10px",
									  }}
									/>
								</Tooltip>
							)}
							<Tooltip title={"Chat"}>
								<Button icon={<MessageFilled />} onClick={toggleChat} 
									style={{
										backgroundColor: "#6c757d",
										color: "#fff",
										borderRadius: "8px",
										borderColor: "#222",
										padding: "10px",
									}}
								/>
							</Tooltip>
							<Tooltip title="Show Participants">
								<Button icon={<UserOutlined />} onClick={showParticipantsModal}
									style={{
										backgroundColor: "#6c757d",
										color: "#fff",
										borderRadius: "8px",
										borderColor: "#222",
										padding: "10px",
									}}
								/>
							</Tooltip>
						</div>
					)}

				<Modal
					title=""
					open={isMoreModalOpen}
					onCancel={closeMoreModal}
					footer={[
						<Button key="close" onClick={closeMoreModal}>
							Close
						</Button>,
					]}>
					<div className="flex flex-col gap-3 mt-10 pl-5">
						<button
							className="flex justify-left font-bold"
							onClick={handleCaseDetail}>
							View Case Details
						</button>
						<EvidenceList />
						{currentUserRole === "COUNSEL" && <UploadEvidence />}
					</div>
				</Modal>
				<Modal
					title="Participants"
					open={isParticipantsModalOpen}
					onCancel={closeParticipantsModal}
					footer={[
						<Button key="close" onClick={closeParticipantsModal}>
							Close
						</Button>,
					]}>
					{/* Displaying list of participants */}
					<List
						itemLayout="horizontal"
						dataSource={participants}
						renderItem={(participant: Participant) => (
							<List.Item>
								<List.Item.Meta
									title={
										<div className="flex justify-between">
											<div style={{ display: "flex", alignItems: "center" }}>
												{participant.displayName}
												{participant.muted ? (
													<AudioMutedOutlined
														style={{ marginLeft: "8px", color: "red" }}
													/>
												) : (
													<AudioOutlined
														style={{ marginLeft: "8px", color: "green" }}
													/>
												)}
											</div>
											{currentUser?.isHost && (
												<div>
													<Button
														icon={<MoreOutlined />}
														onClick={() =>
															showActionModal(
																participant,
																moreButtonRefs.current[participant.userId]
															)
														}
														ref={moreButtonRefs.current[participant.userId]}
													/>
													{selectedParticipant && (
														<Modal
															title=""
															className="w-fit"
															open={isActionModalOpen}
															onCancel={closeActionModal}
															footer={[
																<Button key="close" onClick={closeActionModal}>
																	Close
																</Button>,
															]}
															style={{
																position: "absolute",
																top: modalPosition.middle,
																left: modalPosition.right,
															}}
															getContainer={false}>
															<div className="flex flex-col gap-2">
																<Button
																	onClick={toggleMuteUser}
																	className="w-fit text-left">
																	{selectedParticipant.muted
																		? "Unmute"
																		: "Mute"}
																</Button>
																{!selectedParticipant.isHost && (
																	<Button
																		onClick={kickOutUser}
																		className="w-fit text-left">
																		Kick out {selectedParticipant.displayName}
																	</Button>
																)}
															</div>
														</Modal>
													)}
												</div>
											)}
										</div>
									}
								/>
							</List.Item>
						)}
					/>
				</Modal>
			</div>
		</div>
	);
};

export default VideoContainer;
